// Href seguro para "mapa": solo http(s); cualquier otra cosa (javascript:, data:, relativos) da null.
// Misma barrera que `enlaceSeguro` de Torneos (src/lib/sedes.js); aquí vive suelto porque el Club no tiene sedes.js.
export function enlaceSeguro(url) {
  const texto = String(url ?? '').trim();
  if (!texto) return null;
  try {
    const u = new URL(texto);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.href : null;
  } catch {
    return null;
  }
}
